import z from "zod";
import { mapErrorsToFields } from "../../../../utils";
import ExerciseService from "../../../../services/ExerciseService";
import ExerciseFileService from "../../../../services/ExerciseFileService";

const api = new ExerciseService();
export type State = {
  errors?: {
    name?: string[];
    orderNumber?: string[];
    description?: string[];
    exerciseCategoryId?: string[];
    exerciseLoadTypeId?: string[];
    isActive?: string[];    
    isFree?: string[];
    general?: string[];
  };
  message?: string | null;
  success?: boolean;
  defaultValues?: {
    id?: string;
    name?: string;
    orderNumber?: number;
    description?: string;
    exerciseCategoryId?: string;
    exerciseLoadTypeId?: string;
    isActive?: boolean;
    isFree?: boolean;
  };
};
const FormSchema = z.object({
  name: z.string().min(1, "Name is required."),
  orderNumber: z.int().min(1, "Order Number is required."),
  description: z.string().optional(),
  exerciseCategoryId: z.string().min(1, "Exercise Category is required."),
  exerciseLoadTypeId: z.string().min(1, "Exercise Load Type is required."),
  isActive: z.boolean().optional(),
  isFree: z.boolean().optional(),
});

export async function addExercise(
  prevState: State,
  formData: FormData
): Promise<State> {
  const defaultValues = {
    name: formData.get("name")?.toString() ?? "",
    orderNumber: parseInt( formData.get("orderNumber")?.toString() ?? "1"),
    description: formData.get("description")?.toString() ?? "",
    exerciseCategoryId: formData.get("exerciseCategoryId")?.toString() ?? "",
    exerciseLoadTypeId: formData.get("exerciseLoadTypeId")?.toString() ?? "",
    isActive: formData.get("isActive") === "on" ? true : false,
    isFree: formData.get("isFree") === "on" ? true : false,
  };
  
  try {
    const validatedFields = FormSchema.safeParse(defaultValues);

    if (!validatedFields.success) {
      return {
        success: false,
        errors: mapErrorsToFields(validatedFields.error),
        message: "Missing Fields. Failed to Create Exercise Category.",
      };
    }
  

    const result = await api.addExercise({ ...validatedFields.data});
    if (result.status == 201)
      return {
        message: "Exercise created successfully.",
        success: true,
        defaultValues: result.data,
        errors: {},
      };
    else
      return {
        message: "Failed to create exercise.",
        success: false,
        errors: {},
        defaultValues: defaultValues,
      };
  } catch (e) {
    console.log(e);
    return {
      message: "Failed to create exercise .",
      success: false,
      errors: {},
      defaultValues: defaultValues,
    };
  }
}

export async function updateExercise(
    id: string,
  prevState: State,
  formData: FormData
): Promise<State> {
  const defaultValues = {
    name: formData.get("name")?.toString() ?? "",
    orderNumber: parseInt( formData.get("orderNumber")?.toString() ?? "1"),
    description: formData.get("description")?.toString() ?? "",
    exerciseCategoryId: formData.get("exerciseCategoryId")?.toString() ?? "",
    exerciseLoadTypeId: formData.get("exerciseLoadTypeId")?.toString() ?? "",
    isActive: formData.get("isActive") === "on" ? true : false,
    isFree: formData.get("isFree") === "on" ? true : false,
  };  
  try {
    const validatedFields = FormSchema.safeParse(defaultValues);

    if (!validatedFields.success) {
      return {
        success: false,
        errors: mapErrorsToFields(validatedFields.error),
        message: "Missing Fields. Failed to Update Exercise.",
      };
    }
    
    const result = await api.updateExercise(id, { ...validatedFields.data});
    if (result.status == 204)
      return {
        message: "Exercise updated successfully.",
        success: true,
        defaultValues: defaultValues,
        errors: {},
      };
    else
      return {
        message: "Failed to update exercise.",
        success: false,
        errors: {},
        defaultValues: defaultValues,
      };
  } catch (e) {
    console.log(e);
    return {
      message: "Failed to update exercise.",
      success: false,
      errors: {},
      defaultValues: defaultValues,
    };
  }
}

export async function deleteExercise(id: string, prevState: State) {
  try {
    await api.deleteExercise(id);
    return {
      message: "Exercise deleted successfully.",
      success: true,
    };
  } catch (e) {
    console.log(e);
    return {
      message: "Failed to delete exercise.",
      success: false,
    };
  }
}

// exercise files actions
const apiExerciseFiles = new ExerciseFileService();
export async function addExerciseFile(
  id: string,
  prevState: State,
  formData: FormData
): Promise<{
  message?: string | null;
  success?: boolean;
}> {
  try {
    
    const appFileId = formData.get("appFileId")?.toString() ?? "";
    const orderNumber = parseInt(formData.get("orderNumber")?.toString() ?? "1");
    if (!appFileId) {
      return {
        message: "App File is required.",
        success: false,
      };
    }
    const result = await apiExerciseFiles.addExerciseFile({
      exerciseId: id,
      appFileId,
      orderNumber
    });
    if (result.status == 201)
      return {
        message: "Exercise file added successfully.",
        success: true,
      };
  } catch (e) {}
  return {
    message: "Failed to add exercise file.",
    success: false,
  };
}
export async function deleteExerciseFile(
  id: string,
  prevState: State
): Promise<{
  message?: string | null;
  success?: boolean;
}> {
  try {
    await apiExerciseFiles.deleteExerciseFile(id);
    return {
      message: "Exercise file deleted successfully.",
      success: true,
    };
  } catch (e) {
    console.log(e);
    return {
      message: "Failed to delete exercise file.",
      success: false,
    };
  }  
}

export async function decreaseExerciseFileOrder(
  id: string,
  prevState: State,
   formData: FormData
):Promise<{
  message?: string | null;
  success?: boolean;
}> {
  let orderNumber =parseInt(formData.get("orderNumber")?.toString() ?? "1");
  const exerciseId = formData.get("exerciseId")?.toString() ?? "";
  const appFileId = formData.get("appFileId")?.toString() ?? "";

  if(orderNumber>1)
    orderNumber--;
  else  return {
      message: "Exercise file order updated successfully.",
      success: true,
    };
  const result = await apiExerciseFiles.updateExerciseFile(id,{orderNumber,exerciseId,appFileId})
  if (result.status == 204)
    return {
      message: "Exercise file order updated successfully.",
      success: true,
    };
    else
    return {
      message: "Failed to update exercise file order.",
      success: false,
    };

  
}
  